import comp from "./StandardsSetTable";
export default comp;
